import React, { Component } from 'react'
import EventsListPageUI from './EventsListPageUI'
import EventEditModalSF from '../../../components/superUser/events/EventEditModalSF'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class EventsListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      events: [],
      loading: true,
      error: null,
      editModalOpen: false,
      selectedEvent: null
    }
  }

  componentDidMount() {
    // Fetch events data
    this.fetchEvents()
  }

  fetchEvents = () => {
    // Set loading state
    this.setState({ loading: true })
    
    // Make API call to fetch events
    RestApiUtils.get(
      this.props.context,
      '/api/notifyEvent/getAllEvents',
      this.handleEventsResponse,
      null,
      null
    )
  }
  
  handleEventsResponse = (response) => {
    console.log('Events API response:', response)
    
    if (response && response.events && Array.isArray(response.events)) {
      // Format the events data to match our component needs
      const formattedEvents = response.events.map(event => ({
        id: event.eventId.toString(),
        name: event.eventName,
        category: event.eventGroup,
        status: event.isActive ? 'Active' : 'Inactive',
        adminApprovalRequired: event.requiresApproval,
        reminderIteration: event.iteration,
        createdAt: new Date(event.createdAt).toLocaleDateString(),
        updatedAt: new Date(event.updatedAt).toLocaleDateString(),
        description: event.description,
        loanPhase: event.loanPhase,
        frequencyInDays: event.frequencyInDays,
        // Keep original data for reference
        originalData: event
      }))
      
      this.setState({
        events: formattedEvents,
        loading: false,
        error: null
      })
    } else {
      // Handle error or empty response
      this.setState({
        loading: false,
        error: response.errorList && response.errorList.length > 0 
          ? response.errorList[0].message 
          : 'Failed to fetch events. Please try again later.'
      })
    }
  }

  handleEditClick = (event) => {
    this.setState({
      editModalOpen: true,
      selectedEvent: event
    })
  }

  handleCancelEdit = () => {
    this.setState({
      editModalOpen: false,
      selectedEvent: null
    })
  }

  handleEventUpdated = (updatedEvent) => {
    // Update the event in the list
    const updatedEvents = this.state.events.map(event => {
      if (event.id === updatedEvent.id) {
        return {
          ...event,
          ...updatedEvent
        }
      }
      return event
    })

    this.setState({
      events: updatedEvents
    })

    // Here you would typically update the backend via API call as well
    // updateEventInBackend(updatedEvent);
  }

  render() {
    return (
      <>
        <EventsListPageUI
          context={this.props.context}
          events={this.state.events}
          loading={this.state.loading}
          error={this.state.error}
          onEditClick={this.handleEditClick}
        />

        <EventEditModalSF
          context={this.props.context}
          messageList={[]}
          editMode={this.state.editModalOpen}
          selectedEvent={this.state.selectedEvent}
          onCancel={this.handleCancelEdit}
          onEventUpdated={this.handleEventUpdated}
        />
      </>
    )
  }
}

export default EventsListPageSF
